import { action } from 'mobx';
import i18next from 'i18next';
import Alert from 'react-s-alert';

import { AppManager, Input } from 'core';
import { analytics } from 'core/analytics';

import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';

import { ForumApp } from 'apps/forum/app';
import { ForumMutation } from 'apps/forum/gql';

export class ActivationManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);
    this.forumApp = new ForumApp(this);
    this.forumApp.createForm();
    this.input = new Input({
      spaceId: () => init.spaceId,
      description: () =>
        this.forumApp.description === '<p></p>'
          ? `Welcome to the ${init.initiativeTitle} Forum 👋`
          : this.forumApp.description,
    });
  }

  @action
  Submit = () => {
    if (this.forumApp.form.isValid) {
      this.forumApp.form.SetPosting(true);
      clientStore.SetPosting(true);
      this.mutations.push(
        ForumMutation.New(this.input, {
          onSysErr: this.OnError,
          onUserErr: this.OnError,
          onSuccess: this.OnSuccess,
        }),
      );
    } else {
      this.form.alert();
    }
  };

  @action
  OnError = () => {
    this.forumApp.form.SetPosting(false);
    clientStore.SetPosting(false);
    Alert.error(
      i18next.t('Hmm... We failed to activate your Forum. Please try again.'),
    );
  };

  @action
  OnSuccess = () => {
    this.forumApp.form.SetPosting(false);
    this.forumApp.form.clearDraft();
    clientStore.SetPosting(false);
    modalStore.ClearComponent();
    this.forumManager.NewVariables();
    Alert.success(i18next.t('Forum activated successfully.'));
    analytics.sendEvent('forum-activated');
  };
}
